export default __webpack_public_path__ + "assets/img_objects_own-9f754c87.png";